<template>
  <div>
    <div class="row mt-2 mb-3 align-items-end">
      <div class="col">
        <div class="h4 mb-0 text-uppercase">Activity</div>
      </div>
      <div class="col">
        <div class="text-right text-uppercase" v-if="total > 5">
          <a href="#" class="help-txt branding_text_color font-weight-bold" @click="openNotificationFullListModal()">See All</a>
        </div>
      </div>
    </div>

        <div class="row mb-2 pl-3 pb-2 border-bottom ml-2" v-for="option in 5" v-if="notificationLoading == true">
          <div class="col-12 pl-2 pt-2">
            <div class="col-12">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-10">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
          </div>
        </div>

    <div class="row">
      <div class="col">
        <div class="row mb-2 pl-3" v-for="(activityLog, index) in accountActivityLogs" :key="index">
          <div class="col">
            <div class="row pb-2 border-bottom">
              <div class="col-9">
                <div class="mb-0">{{ activityLog.title }}</div>
                <div v-if="activityLog.title == 'Course Completed'" class="small text-muted mb-0 ">{{ activityLog.description }} <a class="branding_text_color"  style=" cursor: pointer; text-decoration: underline;" v-if="activityLog.cert != ''" @click="viewCourseReport(activityLog.cert)">View Their Certificate</a></div>
                <div v-else-if="activityLog.title == 'Assessment Completed'" class="small text-muted mb-0 ">{{ activityLog.description }} <a style=" cursor: pointer; text-decoration: underline;" class="branding_text_color" v-if="activityLog.UserAssessmetAttemptId != ''" @click="viewReport(activityLog.UserAssessmetAttemptId)">View Their Results</a></div>
                <div v-else class="small text-muted mb-0">{{ activityLog.description }}</div>
              </div>
              <div class="col-3 small text-right text-muted">{{ activityLog.createdAtFormatted }}</div>
            </div>
          </div>
        </div>
        
        

        <div class="row" v-if="accountActivityLogs.length == 0">
          <div class="col">
            <div>No notifications.</div>
          </div>
        </div>


        <NotificationFullList 
          :isModalVisible="isNotificationFullListVisible"
          @closeNotificationFullListModal="closeNotificationFullListModal"
          ref="NotificationFullListModal">
        </NotificationFullList>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import NotificationFullList from '@/components/manager/dashboard_notifications_full_list.vue';

export default {
  data: function () {
    return {
      accountActivityLogs: [],
      limit: 5,
      page: 1,
      total: 0,
      pageCount: 0,
      seeAllText: 'See All',
      showSeeAll: false,
      showSeeMore: false,
      isNotificationFullListVisible: false,
      notificationLoading: false,
    }
  },
  components: {
    NotificationFullList,
  },

  methods: {
    viewCourseReport: function(url) {
        window.open(url, '_blank');
    },
    viewReport: function(id) {
       let routeData = this.$router.resolve({name: 'assessmentreportnew', params: {assessmentAttemptId: id}});
        window.open(routeData.href, '_blank');
    },
    openNotificationFullListModal() {
      this.$refs.NotificationFullListModal.getActivityData();
      this.isNotificationFullListVisible = true;
    },
    closeNotificationFullListModal() {
      this.isNotificationFullListVisible = false;
    },
    handleSeeAll() {
      if (this.seeAllText == 'See All') {
        this.page += 1;
        this.getAccountActivityLogs();
        this.seeAllText = 'See Less';
      } else {
        this.accountActivityLogs = [];
        this.page = 1;
        this.showSeeMore = false;
        this.getAccountActivityLogs();
        this.seeAllText = 'See All';
      }      
    },
    handleSeeMore() {
      this.page += 1;
      this.getAccountActivityLogs();
    },
    getAccountActivityLogs() {
      axios.get('/desktop/v2/manager/get-account-activity-log', {
        params: {
          accountId: this.$store.state.user_accountid,
          limit: this.limit,
          page: this.page,
        }
      })
      .then(response =>  {
        let data = response.data;
        this.accountActivityLogs = this.accountActivityLogs.concat(data.account_activity_logs);
        this.total = data.total_count;
        this.pageCount = data.page_count;
        this.notificationLoading = false;
        if (this.total > this.limit) {
          this.showSeeAll = true;
        }

        if (this.seeAllText == 'See Less' && this.page < this.pageCount) {
          this.showSeeMore = true;
        } else {
          this.showSeeMore = false;
        }
      })
      .catch(function() {});
    },
  },
  created() {
    this.notificationLoading = true;
    this.getAccountActivityLogs();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/manager/dashboard_notifications.vue